/**
 * Get last 4 numbers with **** prefix.
 */
export const getLast4 = (last4: string): string => `****${last4}`;
